// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fJ-z","smallCardRow":"gJ-z","largeCardRow":"hJ-z","productSearchRow":"iJ-z","curatedRow":"jJ-z"};